export const LANGUAGE_STRINGS = {
    NO_RESULTS: "No Results Found",
};

export const LANGUAGE_TABS = {
    TEXTS: "Texts",
	EMAILS: "Emails",
};

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};
